import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import auth from 'state/auth/reducers';
import ui from 'state/ui/reducers';
import errors from 'state/errors/reducer';
import clientConfig from 'state/clientConfig/reducer';
import warnings from 'state/warnings/reducer';
import settings from 'state/settings/reducers';
import directOrder from 'state/direct-order/reducers';
import directOrderRecurring from 'state/direct-order-recurring/reducers';
import mrDistribution from 'state/mrDistribution/reducers';
import mrCollection from 'state/mrCollection/reducers';
import shipments from 'state/shipments/reducer';
import loads from 'state/loads/reducers';
import order from 'state/order/reducers';
import orders from 'state/orders/reducers';
import addresses from 'state/addresses/reducer';
import downloads from 'state/downloads/reducer';
import paymentData from 'state/paymentData/reducers';
import editLog from 'state/editLog/reducers';
import salesIntelligence from 'state/salesIntelligence/reducer';
import status from 'state/status/reducer';

const reducers = {
  settings,
  auth,
  clientConfig,
  ui,
  errors,
  warnings,
  directOrder,
  directOrderRecurring,
  mrDistribution,
  mrCollection,
  shipments,
  loads,
  order,
  orders,
  addresses,
  downloads,
  paymentData,
  editLog,
  salesIntelligence,
  status,
};

const reducerForTest = combineReducers({
  ...reducers,
});

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    ...reducers,
  });

export { reducerForTest };
